import styled from "styled-components";

export const Wrapper = styled.section``;

export const H3 = styled.h3`
  text-align: center;
`;